import React, { type FunctionComponent, Fragment } from 'react'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import DocumentTitle from 'legacy/components/DocumentTitle'
import { ProductsView } from 'domains/products/components/view/ProductsView'
import { usePartnerId, useRetailerId } from 'utils/routing/params.hooks'

interface Props
  extends DashRouteComponentProps<{
    /*
    Add here any properties that you expect to come from the route. For instance,
  */
    productId: string
  }> {}

export const ProductsViewPage: FunctionComponent<Props> = ({ match }) => {
  const retailerId = useRetailerId()
  const partnerId = usePartnerId()

  return (
    <Fragment>
      <DocumentTitle titleId={'productsDomain.view.title'} />

      <ProductsView
        partnerId={partnerId}
        retailerId={retailerId}
        productId={match.params.productId}
      />
    </Fragment>
  )
}
